import { render, staticRenderFns } from "./JobTypeEdit.vue?vue&type=template&id=06bd08bd&"
import script from "./JobTypeEdit.vue?vue&type=script&lang=js&"
export * from "./JobTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports